const css = `._cardContent_1ms2h_1 {
  display: grid;
  gap: 16px;
  padding: 16px 0;
}
._card_1ms2h_1[data-background=noise] ._cardContent_1ms2h_1, ._card_1ms2h_1[data-profiling=border] ._cardContent_1ms2h_1, ._card_1ms2h_1[data-profiling=shadow] ._cardContent_1ms2h_1 {
  padding: 16px;
}
._cardDateTime_1ms2h_9 {
  color: var(--secondary-text-color);
  font-family: var(--font-date-and-tags);
  font-size: 0.8em;
  white-space: nowrap;
}
._cardDescription_1ms2h_15 {
  color: var(--secondary-text-color);
}
._cardHeader_1ms2h_18 {
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-areas: "Text Control";
  grid-template-columns: auto 48px;
}
._cardHeader_1ms2h_18[data-direction=rtl] {
  grid-template-areas: "Control Text";
  grid-template-columns: 48px auto;
}
._cardHeader_1ms2h_18 h3 {
  display: inline-flex;
  grid-area: Text;
  justify-content: flex-start;
}
._cardHeader_1ms2h_18 h3 a svg {
  fill: currentColor;
  height: auto;
  max-height: 24px;
  width: 100%;
}
._cardHeaderControl_1ms2h_40 {
  grid-area: Control;
  justify-self: end;
}
._cardMainImage_1ms2h_44:next-child(._cardContent_1ms2h_1):not(:empty) {
  border-bottom: 1px solid var(--border-color);
}
._cardMainImage_1ms2h_44 img {
  height: auto;
  width: 100%;
}
@media (min-width: 768px) {
  ._cardFadeInUp_1ms2h_52:nth-child(3n-0) {
    animation: _fadeInUp_1ms2h_1 0.25s ease-in-out;
  }
  ._cardFadeInUp_1ms2h_52:nth-child(3n-1) {
    animation: _fadeInUp_1ms2h_1 0.5s ease-in-out;
  }
  ._cardFadeInUp_1ms2h_52:nth-child(3n-2) {
    animation: _fadeInUp_1ms2h_1 0.75s ease-in-out;
  }
}

@keyframes _fadeInUp_1ms2h_1 {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "cardContent": "_cardContent_1ms2h_1",
  "card": "_card_1ms2h_1",
  "cardDateTime": "_cardDateTime_1ms2h_9",
  "cardDescription": "_cardDescription_1ms2h_15",
  "cardHeader": "_cardHeader_1ms2h_18",
  "cardHeaderControl": "_cardHeaderControl_1ms2h_40",
  "cardMainImage": "_cardMainImage_1ms2h_44",
  "cardFadeInUp": "_cardFadeInUp_1ms2h_52",
  "fadeInUp": "_fadeInUp_1ms2h_1"
};